import React from "react";

import Page from "../../../layouts/Main/Page";
import {OptionalContent} from "../../../components/OptionalContent";
import AccommodationSelector from "../AccommodationSelector";
import {useAccommodationsPage} from "../AccommodationContext";
import HomeHeader from './HomeHeader';
import HomeApartmentList from "./HomeApartmentList";
import HomeTabs from "./HomeTabs";
import HomeActionProvider, {useHomeAction} from "./HomeActionContext";
import Apartment from "./Apartment";

import Container from "@mui/material/Container";
import HomeProvider, {useHome} from "./HomeContext";


const Home = () => {
    return <HomeProvider>
        <HomeActionProvider>
            <HomePage/>
        </HomeActionProvider>
    </HomeProvider>

}

const HomePage = () => {
    const {selectedHomeId} = useAccommodationsPage();
    const {isLoading} = useHome()
    const {selectedApartmentId, apartmentDialog} = useHomeAction();

    return <>
        <Page title="Strutture"
              disablePadding
              actions={<AccommodationSelector/>}
              loading={isLoading}
              hidden={selectedApartmentId && apartmentDialog.show}>
            <OptionalContent hasContent={!!selectedHomeId} showIcon noContentMessage="Nessuna casa presente">
                <HomeContent/>
            </OptionalContent>
        </Page>

        {
            // Overlay apartment page
            selectedApartmentId && apartmentDialog.show &&
            <Apartment apartmentId={selectedApartmentId} onClose={apartmentDialog.close}/>
        }
    </>
}

const HomeContent = () => {
    return <Container maxWidth="md"
                      disableGutters={true}
                      sx={{mb: 4}}>
        <HomeHeader/>
        <HomeApartmentList/>
        <HomeTabs/>
    </Container>
}

export default Home;